var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "mb-3", attrs: { cols: "12" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Selecciona el tipo de búsqueda:" } },
                [
                  _c(
                    "b-form-radio-group",
                    {
                      staticClass: "search-toggle",
                      attrs: {
                        buttons: "",
                        "button-variant": "primary",
                        size: "sm",
                      },
                      model: {
                        value: _vm.findByName,
                        callback: function ($$v) {
                          _vm.findByName = $$v
                        },
                        expression: "findByName",
                      },
                    },
                    [
                      _c(
                        "b-form-radio",
                        { attrs: { value: false } },
                        [
                          _c("b-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "hash" },
                          }),
                          _vm._v(" Por CVU "),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-radio",
                        { attrs: { value: true } },
                        [
                          _c("b-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "person" },
                          }),
                          _vm._v(" Por Nombre "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.findByName
            ? _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("h5", [_vm._v(_vm._s(_vm.$t("entity.action.searchCvu")))]),
                  _vm._v(" "),
                  _c(
                    "b-input-group",
                    [
                      _c("b-form-input", {
                        attrs: {
                          autocomplete: "off",
                          placeholder: _vm.$t(
                            "apeironGwApp.movimiento.ingresaCvu"
                          ),
                          type: "number",
                        },
                        on: {
                          keypress: _vm.onlyNumbers,
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.handleFindPersonaByCvu.apply(
                              null,
                              arguments
                            )
                          },
                        },
                        model: {
                          value: _vm.cvuToSearch,
                          callback: function ($$v) {
                            _vm.cvuToSearch =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "cvuToSearch",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "ml-3",
                              attrs: {
                                disabled: _vm.isSearchDisabled,
                                size: "sm",
                                variant: "primary",
                              },
                              on: { click: _vm.handleFindPersonaByCvu },
                            },
                            [
                              !_vm.isSearchingPerfil &&
                              !_vm.isSearchingExpediente
                                ? _c(
                                    "div",
                                    [
                                      _c("b-icon", {
                                        attrs: { icon: "search" },
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "global.process.search.action"
                                            )
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                : _c("span", [
                                    _c("em", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "global.process.search.searching"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("br"),
                ],
                1
              )
            : _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("h5", [_vm._v("Buscar por nombre")]),
                  _vm._v(" "),
                  _c(
                    "b-input-group",
                    [
                      _c("b-form-input", {
                        attrs: {
                          autocomplete: "off",
                          placeholder: "Nombre(s)",
                          value: _vm.nombreBuscar,
                        },
                        on: {
                          input: function ($event) {
                            _vm.nombreBuscar = _vm.formatLettersAndSpace($event)
                          },
                          keydown: _vm.onlyLetters,
                        },
                      }),
                      _vm._v(" "),
                      _c("b-form-input", {
                        attrs: {
                          autocomplete: "off",
                          placeholder: "Primer apellido",
                          value: _vm.primerApellidoBuscar,
                        },
                        on: {
                          input: function ($event) {
                            _vm.primerApellidoBuscar =
                              _vm.formatLettersAndSpace($event)
                          },
                          keydown: _vm.onlyLetters,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "ml-3",
                              attrs: { size: "sm", variant: "primary" },
                              on: { click: _vm.buscarNameExpedientePersona },
                            },
                            [
                              !_vm.isSearchingPerfil &&
                              !_vm.isSearchingExpediente
                                ? _c(
                                    "div",
                                    [
                                      _c("b-icon", {
                                        attrs: { icon: "search" },
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "global.process.search.action"
                                            )
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                : _c("span", [
                                    _c("em", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "global.process.search.searching"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _vm.findByName
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-overlay",
                    {
                      attrs: {
                        show: _vm.isSearchingExpediente,
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-card",
                        { attrs: { title: "Expedientes encontrados" } },
                        [
                          _vm.expedientesEncontrados.length > 0
                            ? _c(
                                "b-list-group",
                                _vm._l(
                                  _vm.expedientesEncontrados,
                                  function (item) {
                                    return _c(
                                      "b-list-group-item",
                                      { key: item.id },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              item.datosGenerales.persona.cvu
                                            ) +
                                            " " +
                                            _vm._s(
                                              item.datosGenerales.persona.nombre
                                            ) +
                                            "\n              " +
                                            _vm._s(
                                              item.datosGenerales.persona
                                                .apellidoPaterno
                                            ) +
                                            " " +
                                            _vm._s(
                                              item.datosGenerales.persona
                                                .apellidoMaterno
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { "label-size": "lg" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("global.process.search.empty")
                                        ) + " "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.nombreBuscar) +
                                            " " +
                                            _vm._s(_vm.primerApellidoBuscar)
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.findByName
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c(
                    "b-overlay",
                    {
                      attrs: {
                        show: _vm.isSearchingPerfil,
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-card",
                        { staticClass: "mb-3", attrs: { title: "Rizoma" } },
                        [
                          !_vm.perfilNotFound
                            ? _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "md",
                                        label: _vm.$t(
                                          "apeironGwApp.persona.cvu"
                                        ),
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.perfilRizoma.cvu)),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "md",
                                        label: _vm.$t(
                                          "apeironGwApp.persona.nombre"
                                        ),
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getFullName(_vm.perfilRizoma)
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "md",
                                        label: _vm.$t(
                                          "apeironGwApp.persona.login"
                                        ),
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.perfilRizoma.login)),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { "label-size": "lg" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("global.process.search.empty")
                                        ) + " "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("apeironGwApp.persona.cvu")
                                          ) +
                                            ": " +
                                            _vm._s(_vm.cvuTyped)
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c(
                    "b-overlay",
                    {
                      attrs: {
                        show: _vm.isSearchingExpediente,
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "mb-3",
                          attrs: { title: "Expediente persona" },
                        },
                        [
                          !_vm.expedienteNotFound
                            ? _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "md",
                                        label: _vm.$t(
                                          "apeironGwApp.persona.cvu"
                                        ),
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.expediente.cvu)),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "md",
                                        label: _vm.$t(
                                          "apeironGwApp.persona.nombre"
                                        ),
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getFullName(_vm.expediente)
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "md",
                                        label: _vm.$t(
                                          "apeironGwApp.persona.correo"
                                        ),
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.expediente.login)),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { "label-size": "lg" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("global.process.search.empty")
                                        ) + " "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("apeironGwApp.persona.cvu")
                                          ) +
                                            ": " +
                                            _vm._s(_vm.cvuTyped)
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.findByName && !_vm.expedienteNotFound
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-overlay",
                    {
                      attrs: {
                        show: _vm.isSearchingExpediente,
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _vm.vigenciaActiva
                        ? _c(
                            "b-card",
                            {
                              staticClass: "mb-3",
                              attrs: {
                                title: _vm.$t(
                                  "apeironGwApp.expediente.vigencia.vigenciaActiva"
                                ),
                              },
                            },
                            [
                              !_vm.expedienteNotFound &&
                              _vm.vigenciaActiva?.activo === true
                                ? _c(
                                    "b-card-body",
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "3" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    "label-size": "md",
                                                    label: _vm.$t(
                                                      "apeironGwApp.expediente.vigencia.tipoVigencia"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.vigenciaActiva?.tipo
                                                          ?.descripcion
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "4" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    "label-size": "md",
                                                    label: _vm.$t(
                                                      "apeironGwApp.expediente.vigencia.nivelSnii"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.vigenciaActiva
                                                          ?.nivelSni
                                                          ?.descripcion
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "3" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    "label-size": "md",
                                                    label: _vm.$t(
                                                      "apeironGwApp.expediente.vigencia.vigenciaFechas"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.formatDate(
                                                            _vm.vigenciaActiva
                                                              ?.vigencia
                                                              ?.fechaInicio
                                                          )
                                                        ) +
                                                        " -\n                    " +
                                                        _vm._s(
                                                          _vm.formatDate(
                                                            _vm.vigenciaActiva
                                                              ?.vigencia
                                                              ?.fechaFin
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "2" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    "label-size": "md",
                                                    label: _vm.$t(
                                                      "apeironGwApp.expediente.vigencia.estatusVigencia"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.vigenciaActiva
                                                          ?.estatusVigencia
                                                          ?.descripcion
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "b-card-body",
                                    [
                                      _c(
                                        "b-form-group",
                                        { attrs: { "label-size": "lg" } },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "global.process.search.empty"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "apeironGwApp.persona.cvu"
                                                )
                                              ) +
                                                ": " +
                                                _vm._s(_vm.cvuTyped)
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.vigenciaActiva && !_vm.ayudantiaActiva
                        ? _c(
                            "b-card",
                            {
                              staticClass: "mb-3",
                              attrs: {
                                title: _vm.$t(
                                  "apeironGwApp.expediente.vigencia.ultimaVigencia"
                                ),
                              },
                            },
                            [
                              !_vm.expedienteNotFound &&
                              (_vm.ultimaVigencia?.activo == false ||
                                _vm.ultimaVigencia?.tipo?.clave === "8")
                                ? _c(
                                    "b-card-body",
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "3" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    "label-size": "md",
                                                    label: _vm.$t(
                                                      "apeironGwApp.expediente.vigencia.tipoVigencia"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ultimaVigencia.tipo
                                                          .descripcion
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "4" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    "label-size": "md",
                                                    label: _vm.$t(
                                                      "apeironGwApp.expediente.vigencia.nivelSnii"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ultimaVigencia
                                                          .nivelSni.descripcion
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "3" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    "label-size": "md",
                                                    label: _vm.$t(
                                                      "apeironGwApp.expediente.vigencia.vigenciaFechas"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.formatDate(
                                                            _vm.ultimaVigencia
                                                              .vigencia
                                                              .fechaInicio
                                                          )
                                                        ) +
                                                        " -\n                    " +
                                                        _vm._s(
                                                          _vm.formatDate(
                                                            _vm.ultimaVigencia
                                                              .vigencia.fechaFin
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "2" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    "label-size": "md",
                                                    label: _vm.$t(
                                                      "apeironGwApp.expediente.vigencia.estatusVigencia"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ultimaVigencia
                                                          .estatusVigencia
                                                          .descripcion
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "b-card-body",
                                    [
                                      _c(
                                        "b-form-group",
                                        { attrs: { "label-size": "lg" } },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "global.process.search.empty"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "apeironGwApp.persona.cvu"
                                                )
                                              ) +
                                                ": " +
                                                _vm._s(_vm.cvuTyped)
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.vigenciaActiva && _vm.ayudantiaActiva
                        ? _c(
                            "b-card",
                            {
                              staticClass: "mb-3",
                              attrs: {
                                title: _vm.$t(
                                  "apeironGwApp.expediente.ayudantia.ayudantiaActiva"
                                ),
                              },
                            },
                            [
                              !_vm.expedienteNotFound &&
                              _vm.ayudantiaActiva?.estadoSolicitud ==
                                "FORMALIZADA"
                                ? _c(
                                    "b-card-body",
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "3" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    "label-size": "md",
                                                    label: _vm.$t(
                                                      "apeironGwApp.expediente.ayudantia.cvuInvestigador"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ayudantiaActiva
                                                          ?.cvuInvestigador
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "2" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    "label-size": "md",
                                                    label: _vm.$t(
                                                      "apeironGwApp.expediente.ayudantia.umas"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ayudantiaActiva
                                                          ?.umas
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "3" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    "label-size": "md",
                                                    label: _vm.$t(
                                                      "apeironGwApp.expediente.ayudantia.periodoAyudantia"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.formatDate(
                                                            _vm.ayudantiaActiva
                                                              ?.vigencia
                                                              ?.fechaInicio
                                                          )
                                                        ) +
                                                        " -\n                    " +
                                                        _vm._s(
                                                          _vm.formatDate(
                                                            _vm.ayudantiaActiva
                                                              ?.vigencia
                                                              ?.fechaFin
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "2" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    "label-size": "md",
                                                    label: _vm.$t(
                                                      "apeironGwApp.expediente.vigencia.estatusVigencia"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ayudantiaActiva
                                                          ?.estadoSolicitud
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "2" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    "label-size": "md",
                                                    label: "Tipo",
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ayudantiaActiva
                                                          ?.tipoMovimiento
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "b-card-body",
                                    [
                                      _c(
                                        "b-form-group",
                                        { attrs: { "label-size": "lg" } },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "global.process.search.empty"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "apeironGwApp.persona.cvu"
                                                )
                                              ) +
                                                ": " +
                                                _vm._s(_vm.cvuTyped)
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.ultimaVigencia &&
                      !_vm.ayudantiaActiva &&
                      _vm.ultimaAyudantia
                        ? _c(
                            "b-card",
                            {
                              staticClass: "mb-3",
                              attrs: {
                                title: _vm.$t(
                                  "apeironGwApp.expediente.ayudantia.ultimaAyudantia"
                                ),
                              },
                            },
                            [
                              !_vm.expedienteNotFound &&
                              _vm.ultimaAyudantia?.vigencia != null
                                ? _c(
                                    "b-card-body",
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "3" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    "label-size": "md",
                                                    label: _vm.$t(
                                                      "apeironGwApp.expediente.ayudantia.cvuInvestigador"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ultimaAyudantia
                                                          ?.cvuInvestigador
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "2" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    "label-size": "md",
                                                    label: _vm.$t(
                                                      "apeironGwApp.expediente.ayudantia.umas"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ultimaAyudantia
                                                          ?.umas
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "3" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    "label-size": "md",
                                                    label: _vm.$t(
                                                      "apeironGwApp.expediente.ayudantia.periodoAyudantia"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.formatDate(
                                                            _vm.ultimaAyudantia
                                                              ?.vigencia
                                                              ?.fechaInicio
                                                          )
                                                        ) +
                                                        " -\n                    " +
                                                        _vm._s(
                                                          _vm.formatDate(
                                                            _vm.ultimaAyudantia
                                                              ?.vigencia
                                                              ?.fechaFin
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "2" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    "label-size": "md",
                                                    label: _vm.$t(
                                                      "apeironGwApp.expediente.vigencia.estatusVigencia"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ultimaAyudantia
                                                          ?.estadoSolicitud
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "2" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    "label-size": "md",
                                                    label: "Tipo",
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ayudantiaActiva
                                                          ?.tipoMovimiento
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "b-card-body",
                                    [
                                      _c(
                                        "b-form-group",
                                        { attrs: { "label-size": "lg" } },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "global.process.search.empty"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "apeironGwApp.persona.cvu"
                                                )
                                              ) +
                                                ": " +
                                                _vm._s(_vm.cvuTyped)
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }